import React from 'react';
import './Process.scss';
import Breadcrumb from '../../components/common/Breadcrumb';
import { useLocation, useNavigate } from 'react-router-dom';

const Process = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const processSteps = [
    { num: '01', title: '원자재 수입', desc: '고품질 원자재 안정적 확보', icon: '🌍' },
    { num: '02', title: '수입 검사', desc: '엄격한 품질 기준 검수', icon: '🔍' },
    { num: '03', title: '원자재 입고', desc: '체계적인 보관 및 관리', icon: '🏭' },
    { num: '04', title: '리와인딩', desc: '정밀 장비 활용 재권취', icon: '🌀' },
    { num: '05', title: '공정 검사', desc: '생산 중 상시 오차 점검', icon: '📊' },
    { num: '06', title: '슬리팅 / 컷팅', desc: '고객 요청 규격 정밀 재단', icon: '✂️' },
    { num: '07', title: '출하 검사', desc: '완제품 최종 품질 확인', icon: '✅' },
    { num: '08', title: '안전 포장', desc: '규격별 완충 포장 진행', icon: '📦' },
    { num: '09', title: '고객 납품', desc: '납기 준수 안정적 배송', icon: '🚚' },
  ];

  return (
    <div className="sub-page process-page">
      {/* 1. 상단 비주얼 (진한 그라데이션 가독성) */}
      <section className="sub-visual facilities">
        <div className="container">
          <span className="sub-title">PRODUCTION SYSTEM</span>
          <h1>제조공정</h1>
          <p>투명한 공정과 철저한 관리로 신뢰를 만듭니다.</p>
        </div>
      </section>

      <Breadcrumb />

      {/* 2. 카테고리 네비게이션 */}
      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/production/facilities')} onClick={() => navigate('/production/facilities')}>
              보유설비
            </button>
            <button className={isActive('/production/process')} onClick={() => navigate('/production/process')}>
              제조공정
            </button>
          </div>
        </div>
      </nav>

      {/* 3. 메인 공정 섹션 (비디오 배경) */}
      <section className="process-main-section">
        <div className="video-bg-container">
          <video autoPlay muted loop playsInline>
            <source src="/videos/process_background.mp4" type="video/mp4" />
          </video>
          {/* 핵심: 비디오를 어둡고 흐리게 만드는 강력한 오버레이 */}
          <div className="video-overlay"></div>
        </div>

        <div className="container content-wrap">
          <div className="process-header">
            <h2>베스트트레이딩 제조 공정</h2>
            <p className="header-desc">원자재 수입부터 최종 납품까지, 모든 공정은 일관된 품질 기준 아래 운영됩니다.</p>
          </div>

          <div className="process-flow-grid">
            {processSteps.map((step, idx) => (
              <div key={idx} className="flow-item">
                <div className="step-card">
                  <div className="card-top">
                    <div className="step-info">
                      <span className="step-badge">{step.num}</span>
                      <h3>{step.title}</h3>
                    </div>
                    <span className="step-icon">{step.icon}</span>
                  </div>
                  <div className="card-bottom">
                    <p>{step.desc}</p>
                  </div>
                </div>
                {/* 커넥터 화살표 */}
                {idx < processSteps.length - 1 && (
                  <div className="connector" aria-hidden="true">
                    <span>→</span>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="process-footer">
            <div className="info-bar">
              <span className="check-icon">✓</span>
              <p>
                모든 공정은 <strong>ISO 품질 경영 시스템</strong> 기준에 따라 정밀하게 운영됩니다.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Process;
